<template>
    <div class="thanks" :style="{ 'background-image' : `url(${background})`}">
        <div class="container">
            <h1>
                <slot name="title" />
            </h1>
            <div class="content">
                <slot name="content" />
            </div>
            <div class="link">
                <slot name="link" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ThanksForSubscribe",
    props: {
        background: {
            type: String,
            default: ""
        }
    }
}
</script>

<style lang="scss">
.thanks {
    background-color: $medium-gray;
    padding: 150px 0 75px 0;
    background-repeat: no-repeat;
    background-position: bottom right;
    overflow: hidden;
    position: relative;

    @media (max-width: $lg) {
        background-size: 75%;
    }

    @media (max-width: $md) {
        background-size: 0%;
    }

    @media (max-width: $sm) {
        padding: 70px 0 40px 0;
    }

    h1 {
        font-size: 45px !important;
        font-weight: 600 !important;
        line-height: 1.11 !important;
        color: white !important;
        margin-bottom: 30px !important;

        @media (max-width: $sm) {
            font-size: 23px !important;
            font-weight: 600 !important;
            font-style: normal !important;
        }
    }

    p {
        font-size: 21px;
        font-weight: 500;
        line-height: 28px;

        @media (max-width: $sm) {
            font-size: 16px;
            font-weight: normal;
            line-height: normal;
        }
    }

    .content {
        width: 90%;

        @media (max-width: $md) {
            width: initial;
        }
    }

    .link {
        font-size: 17px;
        margin-top: 40px;
        display: block;
        font-weight: 600;
    }
}
</style>
